import clsx from 'clsx'
import type { ClassValue } from 'clsx'

/**
 * Conditional class names. Thin wrapper over clsx so the import site never has to
 * care which implementation is underneath (a tailwind-merge upgrade would land here).
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
